import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00c55e11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "formkit-autocomplete-wrapper" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "list-group border-top border-bottom"
}
const _hoisted_4 = {
  key: 0,
  class: "list-group-item list-group-item-action"
}
const _hoisted_5 = ["onClick"]

import { debounce, uniq } from 'lodash'
import { ref } from 'vue'
import AppLoadingMessage from "@/components/app/AppLoadingMessage.vue";

interface Props {
  context: {
    node: {
      input: (value: string) => void
    },
    fetchSuggestions: (query: string) => Promise<string[]>,
    disableAutocomplete: boolean
  }
}

// eslint-disable-next-line vue/require-default-prop

export default /*#__PURE__*/_defineComponent({
  __name: 'FormKitAutocomplete',
  props: {
    context: null
  },
  setup(__props: any) {

const props = __props as {
  context: {
    node: {
      input: (value: string) => void
    },
    fetchSuggestions: (query: string) => Promise<string[]>,
    disableAutocomplete: boolean
  }
};



const showSuggestions = ref(false)
const variants = ref<string[]>([])
const lock = ref({ loadingVariants: false })

const handleInput = debounce(async (e) => {
  const query = e.target.value
  props.context.node.input(query)

  variants.value = []

  if (props.context.disableAutocomplete) {
    return
  }

  showSuggestions.value = true
  lock.value.loadingVariants = true

  try {
    variants.value = uniq([
          query,
          ...(await props.context.fetchSuggestions(query)).filter((v: string | undefined | null) => !!v)
        ]
    )
  } finally {
    lock.value.loadingVariants = false
  }
}, 500)

function chooseVariant (variant: string) {
  props.context.node.input(variant)
  showSuggestions.value = false
  variants.value = []
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      value: props.context._value,
      class: _normalizeClass(__props.context.classes.input),
      autocomplete: "no",
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleInput) && _unref(handleInput)(...args)))
    }, null, 42, _hoisted_2),
    (showSuggestions.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (lock.value.loadingVariants)
            ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                _createVNode(AppLoadingMessage)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant) => {
            return (_openBlock(), _createElementBlock("li", {
              key: variant,
              class: "list-group-item list-group-item-action",
              onClick: ($event: any) => (chooseVariant(variant))
            }, _toDisplayString(variant), 9, _hoisted_5))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})